export enum SettingsPlaybooksDataEventObjectsEnum {
  PLAYBOOK_CREATION_START = 'playbook_creation_start',
  PLAYBOOK_CREATION_SAVE = 'playbook_creation_save',
  PLAYBOOK_EDIT = 'playbook_edit',
  PLAYBOOK_DELETE = 'playbook_delete',
  PLAYBOOK_ADD_STEP = 'playbook_add_step',
  PLAYBOOK_TOGGLE_INFO_BAR = 'playbook_toggle_info_bar',
  PLAYBOOK_ADD_INBOXES = 'playbook_add_inboxes',
  PLAYBOOK_AUTO_SEND = 'playbook_auto_send',
  PLAYBOOK_AUTOPILOT_TRIGGER = 'playbook_autopilot_trigger',
  PLAYBOOK_EXPAND = 'playbook_expand',
  PLAYBOOK_ADD_ESCALATION_INBOX = 'playbook_add_escalation_inbox',
  PLAYBOOK_ADD_ESCALATION_TAG = 'playbook_add_escalation_tag',
  PLAYBOOK_DELETE_STEP = 'playbook_delete_step',
  PLAYBOOK_ENABLED = 'playbook_enabled',

  PLAYBOOK_TESTER = 'playbook_tester',
  PLAYBOOK_TESTER_TEST = 'playbook_tester_test',
  PLAYBOOK_TESTER_TEST_SAVE = 'playbook_tester_test_save',
  PLAYBOOK_TESTER_TEST_EDIT = 'playbook_tester_test_edit',
  PLAYBOOK_TESTER_TEST_AGAIN = 'playbook_tester_test_again',
  PLAYBOOK_TESTER_TEST_DUPLICATE = 'playbook_tester_test_duplicate',
  PLAYBOOK_TESTER_TEST_DELETE = 'playbook_tester_test_delete',
  PLAYBOOK_TESTER_TEST_STEP = 'playbook_tester_test_step',
  PLAYBOOK_TESTER_TEST_SEND_REPLY = 'playbook_tester_test_send_reply',
}
